import React from 'react';
import styled from 'styled-components';
import { Steps } from './ds';

const { Step } = Steps;

const StyledSteps = styled(Steps)`
  margin: 0px var(--spacing-regular) var(--spacing-regular) 0px;
    @media (max-width: 1280px) {
      margin: 0px var(--spacing-regular) var(--spacing-small) 0px;
    }
  .ant-steps-item {
    .ant-steps-item-icon {
      height:10px;
      width:10px;
    }
    &-finish .ant-steps-item-icon {
      background-color: var(--colorSecondary);
      border-color: var(--colorSecondary);
    }
    &-wait .ant-steps-item-icon {
      background-color: var(--colorBorderBase);
      border-color: var(--colorBorderBase);
    }
    .ant-steps-item-icon .ant-steps-icon {
      color: var(--colorSecondary);
      color: transparent;
    }
    .ant-steps-item-content .ant-steps-item-title {
      top: -7px !important;    
      margin-left: -9px;
    }
`;

const ProgressStepper = ({ currentStep, totalSteps }: any) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => (
    <Step key={index} />
  ));

  return (
    <StyledSteps responsive={false} current={currentStep-1} size="small">
      {steps}
    </StyledSteps>
  );
};

export default ProgressStepper;
